import { render, staticRenderFns } from "./EDataComemorativaSaudacao.vue?vue&type=template&id=2e72d68a&scoped=true"
import script from "./EDataComemorativaSaudacao.vue?vue&type=script&lang=js"
export * from "./EDataComemorativaSaudacao.vue?vue&type=script&lang=js"
import style0 from "./EDataComemorativaSaudacao.vue?vue&type=style&index=0&id=2e72d68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72d68a",
  null
  
)

export default component.exports